import { useSafetyTranslation } from 'cng-common/features/translations'
import { AbsolutePopup, PopPaper, TPopupVertical } from 'core-components/library/popup'

import { CockpitIconButton } from '../../../components/cockpitIconButton'
import { MAIL_TO, MS_TEAM_CALL, MS_TEAM_CHAT } from '../../configs'
import {
  companySalesTeamTranslation as KEYS,
  salesTeamRequestTranslation as REQUEST_KEYS,
} from '../../translation'

import styles from './SalesTeamContactActions.module.scss'

export interface ISalesTeamContactAction {
  label: string
  icon: string
  destructive?: boolean
  action: () => void
}

interface Props {
  email: string
  menuItems: ISalesTeamContactAction[]
  disabled?: boolean
}

/** Shared contact controls; request policy and modal state stay in the owning widget. */
export const SalesTeamContactActions = ({ email, menuItems, disabled = false }: Props) => {
  const t = useSafetyTranslation()
  return (
    <div className={styles.actions}>
      <CockpitIconButton
        icon="kbase kbase-email"
        label={t(KEYS.email).replace('{email}', email || '')}
        href={`${MAIL_TO}${email}`}
        disabled={!email || disabled}
      />
      <CockpitIconButton
        icon="kbase kbase-ask-an-expert"
        label={t(KEYS.msTeamCall).replace('{email}', email || '')}
        href={`${MS_TEAM_CALL}${email}`}
        target="_blank"
        disabled={!email || disabled}
      />
      <CockpitIconButton
        icon="kbase kbase-chat"
        label={t(KEYS.msTeamChat).replace('{email}', email || '')}
        href={`${MS_TEAM_CHAT}${email}`}
        target="_blank"
        disabled={!email || disabled}
      />
      {menuItems.length > 0 && (
        <AbsolutePopup
          verticalStartPosition={TPopupVertical.Top}
          verticalDirection={TPopupVertical.Top}
          popupContent={({ action }) => (
            <PopPaper className={styles.menu} shadowPosition="auto">
              {menuItems.map((item) => (
                <button
                  type="button"
                  key={item.label}
                  onClick={() => {
                    action.close()
                    item.action()
                  }}
                >
                  <i
                    className={`${item.icon} ${item.destructive ? styles.destructiveIcon : ''}`}
                    aria-hidden="true"
                  />
                  <span>{item.label}</span>
                </button>
              ))}
            </PopPaper>
          )}
        >
          <CockpitIconButton
            icon="kbase kbase-menu-dots"
            label={t(REQUEST_KEYS.contactActions)}
            disabled={disabled}
          />
        </AbsolutePopup>
      )}
    </div>
  )
}
